import { CcqCards } from './ccqResultView'

export interface CcqResultsSelectionState {
  selectResultIds: string[]
}

export const ccqMatchedListPath = (executionId: string): string => `/cross-client/executions/${executionId}?list=${CcqCards.MATCHED}`

export const ccqResultsSelectionState = (resultIds: string[]): CcqResultsSelectionState => ({ selectResultIds: resultIds })

export const readCcqResultsSelection = (state: unknown): string[] => {
  const resultIds = (state as Partial<CcqResultsSelectionState> | null)?.selectResultIds
  return Array.isArray(resultIds) && resultIds.every((resultId) => typeof resultId === 'string') ? resultIds : []
}
